<script>
/**
 * Render a single slot
 * Either default slot, or an optionally named slot
 * Useful when you need a named component that does nothing but render a template
 * example:
 *  <component :is="check ? 'some-real-component' : 'empty-slot-renderer'">
 *    <template name='some-named-template-that-some-real-component-needs'>foo</template>
 *  </>component>
 */
export default {
  inheritAttrs: false,
  props: {
    slotNameToRender: {
      type: String,
      default: 'default',
    },
  },
  render() {
    return this.$slots[this.slotNameToRender]?.()
  },
}
</script>
